'use client'

import Image from 'next/image'
import { toNumber } from '@helium/spl-utils'
import { BN } from '@coral-xyz/anchor'
import { PublicKey } from '@solana/web3.js'
import { useAsync } from 'react-async-hook'
import {
  auctionManagerKey,
  getPendingStakingRewards,
} from '@dewicats/auction-manager-sdk'
import { useSolana } from '@dewicats/connect-button'
import { tokenByMint } from '@data/tokens'
import SimpleSpinner from '@components/SimpleSpinner'
import { useMint2022 } from '@hooks/useOwnedAmount2022'
import { Holding } from '@hooks/useHoldings'
import { DEWICATS_COLLECTION } from '@utils/constants'
import { NATIVE_MINT } from '@solana/spl-token'
const StakedRewardAmountText = ({
  listing,
  mint,
  holding,
}: {
  listing: PublicKey
  mint: PublicKey
  holding: Holding
}) => {
  const { anchorProvider } = useSolana()
  const { info } = useMint2022(
    mint.toBase58() === NATIVE_MINT.toBase58() ? undefined : mint,
  )

  const { result: rewards, error } = useAsync(async () => {
    return getPendingStakingRewards(
      listing,
      anchorProvider,
      holding.publicKey,
      auctionManagerKey(DEWICATS_COLLECTION, 'dewicats')[0],
    )
  }, [listing, anchorProvider])

  const token = tokenByMint(mint)

  return (
    <div className="flex items-center gap-2">
      {token?.logo && (
        <Image
          src={token.logo}
          alt={token.symbol}
          width={20}
          height={20}
          data-loaded="false"
          onLoad={(event) => {
            event.currentTarget.setAttribute('data-loaded', 'true')
          }}
          className={`data-[loaded=false]:animate-pulse data-[loaded=false]:bg-dark-7 rounded-full`}
        />
      )}
      <p>
        {rewards &&
        (info?.decimals || mint?.toBase58() === NATIVE_MINT.toBase58()) ? (
          toNumber(new BN(rewards), info?.decimals || 9).toLocaleString()
        ) : (
          <SimpleSpinner />
        )}
      </p>
    </div>
  )
}

export default StakedRewardAmountText
